/**
 * Aiká — Cartão-presente
 * Seleção de valor (variante), quantidade, e o formulário de
 * destinatário nativo do Shopify (só aparece/é exigido quando o
 * cliente marca "Enviar como presente").
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.aika-gift-card').forEach((section) => {
    const form = section.querySelector('#aika-gift-card-form');
    const variantIdInput = section.querySelector('[data-variant-id]');
    const priceValue = section.querySelector('[data-price-value]');
    const addToCartBtn = section.querySelector('[data-add-to-cart]');

    const formatMoney = (cents) =>
      (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    // Seleção de valor (variante)
    section.querySelectorAll('[data-variant-select]').forEach((btn) => {
      if (btn.hasAttribute('data-unavailable')) return;
      btn.addEventListener('click', () => {
        section.querySelectorAll('[data-variant-select]').forEach((other) => {
          other.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        if (variantIdInput) variantIdInput.value = btn.dataset.variantId;
        if (priceValue) priceValue.textContent = formatMoney(btn.dataset.variantPrice);
      });
    });

    // Quantidade
    const qtyInput = section.querySelector('[data-quantity-input]');
    const qtyMinus = section.querySelector('[data-quantity-minus]');
    const qtyPlus = section.querySelector('[data-quantity-plus]');

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', () => {
        const current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, current - 1);
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', () => {
        const current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = current + 1;
      });
    }

    // Formulário de destinatário — só entra em jogo quando o checkbox
    // "Enviar como presente" está marcado; nesse caso o e-mail passa a
    // ser obrigatório e a flag que o Shopify exige é preenchida com "true".
    const recipientToggle = section.querySelector('[data-recipient-toggle]');
    const recipientFields = section.querySelector('[data-recipient-fields]');
    const recipientEmail = section.querySelector('[data-recipient-email]');
    const recipientFlag = section.querySelector('[data-recipient-flag]');
    const recipientOffset = section.querySelector('[data-recipient-offset]');
    const recipientSendOn = section.querySelector('[data-recipient-send-on]');

    if (recipientOffset) {
      recipientOffset.value = new Date().getTimezoneOffset();
    }

    if (recipientSendOn) {
      const today = new Date().toISOString().split('T')[0];
      recipientSendOn.setAttribute('min', today);
    }

    if (recipientToggle && recipientFields) {
      recipientToggle.addEventListener('change', () => {
        const isChecked = recipientToggle.checked;
        recipientFields.hidden = !isChecked;

        if (recipientFlag) recipientFlag.value = isChecked ? 'true' : '';
        if (recipientEmail) recipientEmail.required = isChecked;
      });
    }

    if (form) {
      form.addEventListener('submit', (event) => {
        if (recipientToggle && recipientToggle.checked && recipientEmail && !recipientEmail.value) {
          event.preventDefault();
          recipientEmail.focus();
        }
      });
    }
  });
});
